import script from "./MemberBenefitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberBenefitsView.vue?vue&type=script&setup=true&lang=js"

import "./MemberBenefitsView.vue?vue&type=style&index=0&id=7af468e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af468e6"]])

export default __exports__